import styled from 'styled-components';
import { ChatCard } from '@gv/triage-components';

export const Card = styled(ChatCard)`
  padding: ${({ theme }) =>
    theme.responsive.isMobile ? '0px 16px 12px' : '12px 16px'};
`;
